/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Page_TitleInputs */

const vi_packaging_page_title = /** @type {(inputs: Packaging_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vật tư bao bì & định mức`)
};

/**

* @param {Packaging_Page_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_page_title = /** @type {((inputs?: Packaging_Page_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Page_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_page_title(inputs)
});